import * as React from 'react';
import { Column } from 'react-table';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Theme } from '@material-ui/core/styles';
import { localizations } from '../../localization/localization';

const expanderCols = [
    {
        expander: true,
        Header: localizations.common.details,
        width: 100,
        Expander: ({ isExpanded, ...rest }: any) => <div>
            {isExpanded ? <span><ExpandLess /></span> : <span><ExpandMore /></span>}
        </div>
    }
]

export const withExpander = (columns: Column[]) => {
    return [...columns, ...expanderCols];
}

export const withHeaderStyle = (theme: Theme) => (columns: Column[]) => {
    return columns.map(item => {
        return {
            ...item,
            getHeaderProps: () => ({
                style: {
                    fontWeight: "bold",
                    color: theme.palette.primary.main
                }
            }),
        }
    })
}


// WEBPACK FOOTER //
// ./src/components/tables/TableUtils.tsx